import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'POWER',
  category: FunctionCategory.MATH,
  description: 'Raises each number in a column or a single number to the power of a column or number.',
  shortDescription: 'Raises to a power',
  params: [
    {
      name: 'base',
      type: ArgType.number,
      description: 'Either a column or number to raise to the exponent power.',
    },
    {
      name: 'exponent',
      type: ArgType.number,
      description: 'Either a column or number to be used as the exponent.',
    },
  ],
} satisfies AnalysisFunction;
